import '../../style/index.less';
import './index.less'; // style dependencies

import '../../empty/style';
import '../../spin/style';
import '../../pagination/style';
import '../../grid/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/list/style/index.js
// module id = 1761
// module chunks = 0